/**
 * Omits keys from an object
 *
 * @param obj Object to omit keys from
 * @param objectKeys Keys to omit
 *
 * @returns New object with omitted keys
 *
 * @example
 * const obj = { a: 1, b: 2, c: 3 };
 * const objectKeys = ['b', 'c'];
 * const result = omit(obj, objectKeys);
 * // result = { a: 1 };
 */
function omit<T extends object, P extends keyof T>(obj: T, objectKeys: P | P[]): Omit<T, P> {
  const result = { ...obj };

  // Normalize input to an array to handle both single keys and arrays of keys
  const keysToRemove = Array.isArray(objectKeys) ? objectKeys : [objectKeys];

  for (const key of keysToRemove) {
    delete result[key];
  }

  return result;
}

export { omit };
